import React, { useContext, useState } from 'react';

import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import { useRouter } from 'next/router';

import { HeaderContext } from '../../common/Header/HeaderContext';
import Link from '../Link';
import { IDropdownProps } from './DropdownMenu.types';

const DropdownMenu: React.FC<IDropdownProps> = ({ entry, subMenuState, className }) => {
  const headerContext = useContext(HeaderContext);
  const [openKey, setOpenKey] = useState<string>('/product/fx-management/');
  if (!headerContext) {
    throw new Error('HeaderContext is null. Ensure the provider is set.');
  }
  const { headerStyles, currentPath, setMenuState, isMobile } = headerContext;
  const router = useRouter();

  const navigateTo = (path: string) => {
    setMenuState(false);
    // Implement your navigation logic here
    // For example, using react-router:
    // history.push(path);
    router.push(path);
  };
  return (
    <div
      className={classNames(headerStyles.menu__dropdown, {
        [headerStyles.menu__dropdown_active]: subMenuState,
        ...(className ? { [className]: !!className } : {}),
      })}
      data-testid="dropdown"
    >
      <ul className={headerStyles.subMenu}>
        {entry?.items?.map((item) => {
          const normalizePath = (path: string) => path.replace(/\/+$/, ''); // Remove trailing slash

          const isActive =
            normalizePath(currentPath) === normalizePath(item.path) || // Exact match
            normalizePath(currentPath).startsWith(normalizePath(item.path) + '/'); // Subpath match only

          return (
            <li
              key={item.label}
              onMouseEnter={() => !isMobile && setOpenKey(item.path)}
              onMouseLeave={() => !isMobile && setOpenKey('')}
              className={classNames(headerStyles.subMenu__item, {
                [headerStyles.item__active]: isActive,
              })}
            >
              <div className={headerStyles.linkWrapper} onClick={() => navigateTo(item.path)}>
                <Link
                  to={item.path}
                  title={item.title}
                  onClick={() => setMenuState(false)}
                  data-testid="dropdown-label"
                >
                  {item.label}
                </Link>
              </div>
              {/* {isMobile && !!item.items?.length && (
                <ChevronDown
                  onClick={(e) => {
                    e.stopPropagation();
                    isMobile && setOpenKey(openKey === item.path ? '' : item.path);
                  }}
                  className={headerStyles.chevron}
                />
              )} */}
              {/* {!!item.items?.length ? (
                <DropdownMenu
                  entry={item}
                  subMenuState={openKey === item.path}
                  className={headerStyles.menu__dropdown_nested}
                />
              ) : null} */}
              <div className={headerStyles.subMenu__item__children__wrapper}>
                {!!item.items?.length
                  ? item.items.map((subItem) => {
                      const isSubActive =
                        normalizePath(currentPath) === normalizePath(subItem.path) ||
                        normalizePath(currentPath).startsWith(normalizePath(subItem.path) + '/');

                      return (
                        <div
                          key={subItem.label}
                          className={classNames(headerStyles.subMenu__item__children, {
                            [headerStyles.item__active]: isSubActive,
                          })}
                        >
                          <Link
                            to={subItem.path}
                            title={subItem.title}
                            onClick={() => setMenuState(false)}
                            data-testid="dropdown-label"
                          >
                            {subItem.label}
                          </Link>
                        </div>
                      );
                    })
                  : null}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DropdownMenu;
